import React from 'react'
import NumberRow from '../Rows/NumberRow'
import TextRow from '../Rows/TextRow'
import { Shadow } from '../../types/Shadow.types'
import { FormTabProps } from '../../types/FormTab.types'

const SynchronizationConfigurationSection = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const inputChanged = handleChangeByShadow(Shadow.Datasyncd)

    return (
        <>
            <NumberRow
                label="Interwał synchronizacji w sekundach"
                caption="SYNCD_INTERVAL_SEC"
                name="datasyncd.SYNCD_INTERVAL_SEC"
                value={formState.datasyncd.SYNCD_INTERVAL_SEC}
                onChange={inputChanged}
            />

            <NumberRow
                label="Ilość miesięcy przechowywania transakcji"
                caption="SYNCD_MONTHSBACK"
                name="datasyncd.SYNCD_MONTHSBACK"
                value={formState.datasyncd.SYNCD_MONTHSBACK}
                onChange={inputChanged}
            />

            <TextRow
                label="Ścieżka do zdjęć"
                caption="SYNCD_STORAGEDIR"
                name="datasyncd.SYNCD_STORAGEDIR"
                value={formState.datasyncd.SYNCD_STORAGEDIR}
                onChange={inputChanged}
            />

            <TextRow
                label="Ścieżka do bazy danych"
                caption="DB_SQLITE_PATH"
                name="datasyncd.DB_SQLITE_PATH"
                value={formState.datasyncd.DB_SQLITE_PATH}
                onChange={inputChanged}
            />
        </>
    )
}

export default SynchronizationConfigurationSection